export const CALENDARNAV_CALENDAR_VIEW = 'REDUX_CALENDARNAV_CALENDAR_VIEW';
export const CALENDARNAV_LIST_VIEW = 'REDUX_CALENDARNAV_LIST_VIEW';
export const CALENDARNAV_HYBRID_VIEW = 'REDUX_CALENDARNAV_HYBRID_VIEW';
export const CALENDARNAV_RESET = 'REDUX_CALENDARNAV_RESET';

export const actionCalendarNavCalendarView = (dispatch) => {
    dispatch({ type: CALENDARNAV_CALENDAR_VIEW });
};

export const actionCalendarNavListView = (dispatch) => {
    dispatch({ type: CALENDARNAV_LIST_VIEW });
};

export const actionCalendarHyridView = (dispatch) => {
    dispatch({ type: CALENDARNAV_HYBRID_VIEW });
};

export const actionCalendarNavReset = (dispatch) => {
    dispatch({ type: CALENDARNAV_RESET });
};
